import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ERoomType } from '../types/rooms';
var ROOM_TYPE_FILTERS = ['room1', 'room2', 'room3', 'room4', 'room5', 'room6', 'room7', 'room9'];
var ROOM_TYPE_FILTERS_MAP = {
  room1: ERoomType.OneRoom,
  room2: ERoomType.TwoRoom,
  room3: ERoomType.ThreeRoom,
  room4: ERoomType.FourRoom,
  room5: ERoomType.FiveRoom,
  room6: ERoomType.Large,
  room7: ERoomType.OpenPlan,
  room9: ERoomType.Studio
};
export var getFilterParams = function getFilterParams(isQueryParamsEnabled) {
  if (typeof window === 'undefined' || !isQueryParamsEnabled) {
    return {
      roomTypes: []
    };
  }
  var roomTypes = [];
  var searchParams = new URLSearchParams(window.location.search);
  var _iterator = _createForOfIteratorHelper(searchParams.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      if (ROOM_TYPE_FILTERS.includes(key) && value === '1') {
        roomTypes.push(ROOM_TYPE_FILTERS_MAP[key]);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    roomTypes: roomTypes
  };
};
export var setRoomQueryParams = function setRoomQueryParams(roomTypes) {
  if (typeof window === 'undefined') {
    return;
  }
  var searchParams = new URLSearchParams(window.location.search);
  for (var _i = 0, _ROOM_TYPE_FILTERS = ROOM_TYPE_FILTERS; _i < _ROOM_TYPE_FILTERS.length; _i++) {
    var roomFilter = _ROOM_TYPE_FILTERS[_i];
    var filter = ROOM_TYPE_FILTERS_MAP[roomFilter];
    if (roomTypes.includes(filter)) {
      searchParams.set(roomFilter, '1');
    } else {
      searchParams.delete(roomFilter);
    }
  }
  var url = "".concat(window.location.pathname, "?").concat(searchParams.toString());
  window.history.pushState(null, document.title, url);
};